// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-enter[data-v-686b9500]{opacity:0}.v-enter-active[data-v-686b9500],.v-leave-active[data-v-686b9500]{transition:opacity .25s ease}.v-enter-from[data-v-686b9500],.v-leave-to[data-v-686b9500]{opacity:0}", ""]);
// Exports
module.exports = exports;
